<template>
    <div id="app">
        <div class="loading-global" v-if="loadingGlobalStatus">
            <a-spin :tip="loadingGlobalStatus">
                <a-icon slot="indicator" type="loading" style="font-size: 55px" spin />
            </a-spin>
            <a-button type="primary" class="clear-cache" @click="onClearCache">长时间无响应请点这里清除缓存后重新登录</a-button>
        </div>
        <transition appear name="tvplay">
            <div v-if="showRoutePage" class="route-page">
                <u-menu />
                <div class="content">
                    <u-header />
                    <div class="router-view">
                        <div class="loading" v-if="loadingStatus">
                            <a-spin :tip="loadingStatus">
                                <a-icon slot="indicator" type="loading" style="font-size: 45px" spin />
                            </a-spin>
                        </div>
                        <a-config-provider :locale="zh_CN">
                            <transition name="scale" mode="out-in">
                                <keep-alive :include="getCachedRoutePath">
                                    <router-view />
                                </keep-alive>
                            </transition>
                        </a-config-provider>
                    </div>
                </div>
            </div>
        </transition>
        <login v-if="!showRoutePage" />
    </div>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapMutations
} from 'vuex'
import {
    getMenus,
    routes
} from '@/components/router'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'

import Login from '@/common/required-components/login/login'
import UMenu from '@/components/basic/menu'
import UHeader from '@/components/basic/header'

export default {
    name: 'app',
    computed: {
        ...mapState('global', ['menuPermitted', 'loadingGlobalStatus', 'loadingStatus']),
        ...mapState('stored', ['userInfo']),
        ...mapGetters('global', ['getCachedRoutePath']),
        ...mapGetters('stored', ['showRoutePage'])
    },
    data() {
        return {
            zh_CN
        }
    },
    components: {
        Login,
        UMenu,
        UHeader
    },
    beforeMount() {
        this.setCachedRoute(this.$route)
        this.checkRouteValidation()
    },
    beforeUpdate() {
        this.checkRouteValidation()
    },
    watch: {
        $route(cur) {
            this.setCachedRoute(cur)
        }
    },
    methods: {
        ...mapMutations('global', ['setCachedRoute', 'setMenuPermitted', 'setLoadingGlobal']),
        onClearCache() {
            localStorage.clear()
            location.reload()
        },
        async checkRouteValidation() {
            if (!this.showRoutePage) {
                return
            }
            if (this.menuPermitted.length) {
                if (routes.map((s) => s.children ? s.children : s).flat().map((s) => s.meta.routeName).includes(
                    this.$route.path
                )) {
                    if (!this.menuPermitted.includes(this.$route.path)) {
                        this.$router.push('/401')
                    }
                } else {
                    this.$router.push('/404')
                }
            } else {
                this.setLoadingGlobal('路由加载中...')
                this.setMenuPermitted(await getMenus(this.userInfo.role, this.userInfo.stationId))
                this.setLoadingGlobal('')
            }
        }
    }
}
</script>

<style lang="less">
    @import "~@/App.less";
</style>
